/**
 *  ######################################
 *  ### DO NOT EDIT THIS FILE DIRECTLY ###
 *  ######################################
 *
 * This file is generated from:
 * /crates/mgo-open-rpc/spec/openrpc.json
 */

import type { GetNormalizedMoveStructParams } from '@mgonetwork/mango.js/client';

import type { UseMgoClientQueryOptions } from '../useMgoClientQuery.js';
import { useMgoClientQuery } from '../useMgoClientQuery.js';

export function useNormalizedMoveStruct(
	params: GetNormalizedMoveStructParams,
	options?: UseMgoClientQueryOptions<'getNormalizedMoveStruct'>,
) {
	return useMgoClientQuery(
		{
			method: 'getNormalizedMoveStruct',
			params,
		},
		options,
	);
}
